import type { ApiErrorResponse } from './auth.types'

export function normalizeApiError(
  error: unknown,
  fallbackMessage: string,
): ApiErrorResponse {
  if (typeof error === 'object' && error !== null) {
    const asRecord = error as Record<string, unknown>
    const rawData =
      typeof asRecord.data === 'object' && asRecord.data !== null
        ? (asRecord.data as Record<string, unknown>)
        : null

    if (rawData) {
      const message =
        typeof rawData.message === 'string' ? rawData.message : fallbackMessage
      const statusCode =
        typeof rawData.statusCode === 'number'
          ? rawData.statusCode
          : typeof asRecord.status === 'number'
            ? asRecord.status
            : 500
      const apiError =
        typeof rawData.error === 'string' ? rawData.error : 'Internal Server Error'
      const retryAfterSeconds =
        typeof rawData.retryAfterSeconds === 'number'
          ? rawData.retryAfterSeconds
          : undefined

      return { message, statusCode, error: apiError, retryAfterSeconds }
    }

    if (
      typeof asRecord.message === 'string' &&
      typeof asRecord.statusCode === 'number'
    ) {
      return {
        message: asRecord.message,
        statusCode: asRecord.statusCode,
        error:
          typeof asRecord.error === 'string'
            ? asRecord.error
            : 'Internal Server Error',
      }
    }
  }

  return {
    message: fallbackMessage,
    error: 'Internal Server Error',
    statusCode: 500,
  }
}
